export const environment = {
  environment: 'staging',
  baseUrl: 'https://staging.lesexplorateursdumonde.com/',
  apiUrl: 'https://staging.lesexplorateursdumonde.com/graphql/',
};
